<template>
  <div class="info-page">
    <h1 class="page-heading" v-if="pageTitleBlock && isDisplayingDoctorInfo">
      {{ pageTitleBlock.title }}
    </h1>

    <div class="info-display">
      <div class="breadcrumbs" v-if="breadcrumbsDisplay && !isDisplayingDoctorInfo">{{ breadcrumbsDisplay }}</div>

      <h2 class="main-title" v-if="!isDisplayingDoctorInfo">
        <template v-if="pageTitleBlock">
          {{ pageTitleBlock.title }}
        </template>
        <template v-else>
          {{ mainTitleDisplay }}
        </template>
      </h2>
      <div v-if="!isDisplayingDoctorInfo && pageTitleTextContent" class="main-title-text-card">
        <p class="main-title-text">{{ pageTitleTextContent }}</p>
      </div>

      <div class="info-card-wrapper">
        <template v-for="(block, index) in contentBlocks">
          <div v-if="block.type === 'html'" :key="`html-${index}`" class="info-card">
            <InfoHtml :title="block.title" :content="block.content" :alt="block.alt" :list-unstyled="block.listUnstyled" />
          </div>
          <div v-else :key="`card-${index}`" class="info-card">
            <InfoText v-if="block.type === 'text'" :title="block.title" :content="block.content" />
            <InfoTextEmphasized v-else-if="block.type === 'text-emphasized'" :title="block.title" :content="block.content" />
            <div v-else-if="block.type === 'price'" class="price-block">
              <h3 class="price-title">{{ block.title || '費用' }}</h3>
              <p v-if="block.price" class="price-value">
                {{ block.price }}{{ priceUnit }}
                <span v-if="block.textContent" class="price-value-text">{{ block.textContent }}</span>
              </p>
            </div>
            <InfoImage v-if="block.type === 'image'" :title="block.title" :src="block.src" :alt="block.alt" />
            <InfoAccordion v-else-if="block.type === 'accordion'" :title="block.title" :content="block.content" />
          </div>
        </template>
      </div>

      <!-- <div class="main-image">
        <img :src="mainImageUrl" alt="Doctor illustration" />
      </div> -->
    </div>
  </div>
</template>


<script>
import InfoHtml from './common/InfoHtml.vue';
import InfoText from './common/InfoText.vue';
import InfoTextEmphasized from './common/InfoTextEmphasized.vue';
import InfoImage from './common/InfoImage.vue';
import InfoAccordion from './common/InfoAccordion.vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'InfoDisplay',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    InfoHtml,
    InfoText,
    InfoTextEmphasized,
    InfoImage,
    InfoAccordion,
  },
  computed: {
    ...mapGetters('web/tongxin', ['sourceType']),
    isDisplayingDoctorInfo() {
      return this.sourceType === 'outpatient'
    },
    priceUnit() {
      return this.sourceType === 'vaccine' ? '元/劑' : '元';
    },
    breadcrumbsDisplay() {
      return _.get(this.data, 'breadcrumbs[0]', '');
    },
    mainTitleDisplay() {
      if (!this.data || !Array.isArray(this.data.breadcrumbs) || this.data.breadcrumbs.length === 0) {
        return this.data ? this.data.outer_title : '';
      }

      const breadcrumbs = this.data.breadcrumbs;
      if (breadcrumbs.length >= 4) {
        // 有四層時，顯示 第三層(第四層) (例如: "健康多點套組 (男)")
        return `${breadcrumbs[2]} (${breadcrumbs[3]})`;
      } else if (breadcrumbs.length >= 3) {
        return breadcrumbs[2];
      } else if (breadcrumbs.length >= 2) {
        return breadcrumbs[1];
      }

      return this.data.outer_title;
    },
    pageTitleBlock() {
      return (this.data?.subsequent_texts || []).find(block => block.type === 'pageTitle');
    },
    pageTitleTextContent() {
      return this.pageTitleBlock?.textContent ? this.pageTitleBlock.textContent.trim() : '';
    },
    contentBlocks() {
      return (this.data?.subsequent_texts || []).filter(block => block.type !== 'pageTitle');
    },
  },
};
</script>


<style lang="scss" scoped>
.info-page {
  @media (min-width: 768px) {
    padding: 0 32px;
  }
}

.info-display {
  background-color: #ffffff;
  font-family: 'Helvetica Neue', sans-serif;
}

.main-title {
  font-size: 28px;
  font-weight: bold;
  color: #207868;
  margin-bottom: 10px;
}

.main-title-text {
  color: #000000;
  font-size: 20px;
  margin: 0;
}

.main-title-text-card {
  margin-bottom: 24px;
}

.breadcrumbs {
  font-size: 16px;
  font-weight: 500;
  color: #207868;
  margin-bottom: 24px;

  &::after {
    content: '';
    display: block;
    height: 1px;
    background-color: #d1d9d8;
    width: 100%;
    margin-top: 8px;
  }
}

.info-card-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #ffffff;
}

.info-card {
  background-color: #f5f7f8;
  border-left: 6px solid #1f9c7b;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.price-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.price-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.price-value {
  padding: 24px 32px;
  border-radius: 16px;
  background: linear-gradient(135deg, #207868 0%, #2a9d8f 100%);
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 10px 30px rgba(32, 120, 104, 0.3);
  margin: 0;

  @media (min-width: 768px) {
    font-size: 48px;
  }
}

.price-value-text {
  display: block;
  margin-top: 8px;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
}

.price-text-content {
  margin: 0;
  color: #4f4f4f;
  font-size: 20px;
  line-height: 1.6;
  white-space: pre-line;
}

.main-image {
  img {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    display: block;
    border-radius: 8px;

    @media (min-width: 768px) {
      height: 60vh;
    }
  }
}
</style>
